import React, { useMemo } from "react";
import {
  RadarChart,
  PolarGrid,
  Radar,
  Tooltip,
  PolarAngleAxis,
} from "recharts";
import "./DuplicateData.scss";
import { numberFormatter } from "../../../components/common/Dashboard/utils";

const SmallTooltip = ({ active, payload, loc }) => {
  if (!active || !payload || !payload.length) return null;

  const item = payload[0].payload;
  const isTypesData = loc === "TypesData";


  return (
    <div className="spider-tooltip-small">
      <div className="st-title">{item.type}</div>

      {isTypesData ? null : (
        <div className="st-row">
          <span className="st-dot duplicate-dot" />
          Duplicate: {numberFormatter(item.duplicate)}
        </div>
      )}
    </div>
  );
};


const TypeAxisLabel = ({ payload, x, y, cx }) => {
  const isLeft = x < cx;

  return (
    <text
      x={x}
      y={y}
      textAnchor={isLeft ? "end" : "start"}
      dominantBaseline="middle"
      fontSize={10}
      fill="#6b7280"
    >
      {payload.value.length > 14
        ? `${payload.value.slice(0, 14)}…`
        : payload.value}
    </text>
  );
};

const SpiderChartSmall = ({ data, loc }) => {
  const isTypesData = loc === "TypesData";

  const chartData = useMemo(() => {
    if (!isTypesData) return data;

    const logs = data.map((d) => Math.log10((d.total || 0) + 1));
    const maxLog = Math.max(...logs, 1);

    return data.map((d, idx) => ({
      ...d,
      total: (logs[idx] / maxLog) * 100,
      duplicate: 0,
    }));
  }, [data, isTypesData]);

  const size = isTypesData
    ? { width: 160, height: 160, outerRadius: 60 }
    : { width: 70, height: 70, outerRadius: 30 };

  return (
    <div className={`dd-radar-chart ${isTypesData ? "large" : ""}`}>
      <RadarChart
        data={chartData}
        width={size.width}
        height={size.height}
        outerRadius={size.outerRadius}
      >
        <PolarGrid gridType="circle" />

        {isTypesData && (
          <PolarAngleAxis
            dataKey="type"
            tickLine={false}
            axisLine={false}
            tick={(props) => <TypeAxisLabel {...props} />}
          />
        )}

        {!isTypesData && (
          <Tooltip
            cursor={false}
            position={isTypesData ? { x: 80, y: 10 } : { x: -60, y: 10 }}
            content={<SmallTooltip loc={loc} />}
          />
        )}

        {isTypesData ? (
          <Radar
            name="total"
            dataKey="total"
            stroke="#7B61FF"
            fill="#7B61FF"
            fillOpacity={0.4}
          />
        ) : (
          <Radar
            name="duplicate"
            dataKey="duplicate"
            stroke="#FF4D4F"
            fill="#FF4D4F"
            fillOpacity={0.3}
          />
        )}
      </RadarChart>
    </div>
  );
};

export default SpiderChartSmall;
